/**
 * AppleAuthComplete — lands here after the backend finishes the Sign in
 * with Apple round-trip (POST /api/auth/apple/callback already set the
 * httpOnly session cookie). Fetch the profile to populate local state
 * the rest of the app reads, then return the guest to wherever they
 * started (stored by AppleSignInButton before the redirect).
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AppleAuthComplete() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const dest = sessionStorage.getItem('apple_auth_return_to') || '/';
    sessionStorage.removeItem('apple_auth_return_to');
    const params = new URLSearchParams(window.location.search);
    const run = async () => {
      if (params.get('error')) {
        toast.error('Apple sign-in failed — please try again.');
        navigate(dest, { replace: true });
        return;
      }
      try {
        const r = await axios.get(`${API_BASE}/auth/profile`);
        localStorage.setItem('user_token', 'cookie-session-user');
        localStorage.setItem('token', 'cookie-session-user');
        localStorage.setItem('user', JSON.stringify(r.data));
        localStorage.setItem('user_data', JSON.stringify(r.data));
        window.dispatchEvent(new Event('loginStateChanged'));
        toast.success(`Welcome, ${r.data.full_name || 'traveler'}!`);
      } catch {
        toast.error('Apple sign-in failed — please try again.');
      }
      navigate(dest, { replace: true });
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="apple-auth-complete">
      <div className="w-8 h-8 border-2 border-[#1E3F70] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
